"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TrashIcon = function TrashIcon(_ref) {
  var color = _ref.color,
    width = _ref.width,
    height = _ref.height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 13 15",
    fill: "none",
    stroke: color,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0.888672 3.88889H12.4442M11.722 3.88889L11.0958 12.6581C11.0699 13.0225 10.9068 13.3636 10.6395 13.6126C10.3721 13.8616 10.0203 14 9.65501 14H3.67789C3.31255 14 2.96078 13.8616 2.69342 13.6126C2.42607 13.3636 2.263 13.0225 2.23706 12.6581L1.61089 3.88889H11.722ZM5.22201 6.77778V11.1111V6.77778ZM8.11089 6.77778V11.1111V6.77778ZM8.83312 3.88889V1.72222C8.83312 1.53068 8.75702 1.34698 8.62158 1.21153C8.48614 1.07609 8.30244 1 8.11089 1H5.22201C5.03046 1 4.84676 1.07609 4.71132 1.21153C4.57587 1.34698 4.49978 1.53068 4.49978 1.72222V3.88889H8.83312Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
TrashIcon.propTypes = _utils.iconProps;
TrashIcon.defaultProps = {
  color: 'white',
  width: '20',
  height: '20'
};
var _default = TrashIcon;
exports.default = _default;